/* eslint-disable no-sparse-arrays */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import BrokerFeeSection from "../components/BrokerFeeSection";
import { Oval } from "react-loader-spinner";
// import { LoaderContext } from "../Context/Loader";
import Select from 'react-select'
// import securites from "./../assets/img/brokerlogoclient/ACY Securities logo.jpg";
// import axi from "./../assets/img/brokerlogoclient/Axi logo.png";
// import avatrade from "./../assets/img/brokerlogoclient/AvaTrade logo.jpg";
// import cmc from './../assets/img/CMC Markets Logo.png'
import axi from "./../assets/img/brokerlogoclient/Axi logo.png";
// import captial from "./../assets/img/brokerlogoclient/Capital.com logo2.png";
import cityindex from "./../assets/img/brokerlogoclient/City Index logo.png";
import avatrade from "./../assets/img/brokerlogoclient/AvaTrade logo.jpg";
import captial from "./../assets/img/brokerlogoclient/Capital.com logo.png";
import admiralmarket from "./../assets/img/brokerlogoclient/Admirals Markets logo.png";
import blackbull from "./../assets/img/brokerlogoclient/Blackbull logo.png";
import Eightcap from "./../assets/img/brokerlogoclient/EightCap logo.png";
import etoro from "./../assets/img/brokerlogoclient/eToro logo.png";
import forexcom from "./../assets/img/brokerlogoclient/forex.com logo.png";
import fpmarket from "./../assets/img/brokerlogoclient/FP Markets logo.png";
import fusionmarket from "./../assets/img/brokerlogoclient/Fusion Markets logo.jpg";
import fxcmlogo from "./../assets/img/brokerlogoclient/FXCM logo.png";
import fxpro from "./../assets/img/brokerlogoclient/Fxpro logo.svg";
import fxtm from "./../assets/img/brokerlogoclient/FXTM logo2.png";
import globalprime from "./../assets/img/brokerlogoclient/Global Prime Logo.png";
import gomarket from "./../assets/img/brokerlogoclient/Go Markets logo.jpeg";
import HFmarket from "./../assets/img/brokerlogoclient/HF Markets.png";
import Hycmlogo from "./../assets/img/brokerlogoclient/HYCM logo.png";
import ICmarket from "./../assets/img/brokerlogoclient/IC Markets logo2.png";
import IG from "./../assets/img/brokerlogoclient/IG Logo.jpg";
import marketcom from "./../assets/img/brokerlogoclient/Markets.com logo.jpeg";
import monetamarket from "./../assets/img/brokerlogoclient/Moneta Markets logo2.png";
import multibank from "./../assets/img/brokerlogoclient/MultiBank logo.svg";
import oandalogo from "./../assets/img/brokerlogoclient/Oanda Logo.jpg";
import peperstone from "./../assets/img/brokerlogoclient/Pepperstone logo.png";
import swisslogo from "./../assets/img/brokerlogoclient/Swissquote logo.png";
import tickmil from "./../assets/img/brokerlogoclient/Tickmill logo.png";
import tmgm from "./../assets/img/brokerlogoclient/TMGM logo.jpeg";
import xtm from "./../assets/img/brokerlogoclient/XM logo.jpg";
import activetrade from "./../assets/img/main-icon.jpg";
import XTB from "./../assets/img/Xtb-logo.png";
import tradenation from "./../assets/img/brokerlogoclient/Trade Nation logo.png";
import vintage from "./../assets/img/brokerlogoclient/Vantage logo.png";
import plus500 from "./../assets/img/brokerlogoclient/Plus500 logo2.png";
// import BrokerFee from "../components/BrokerFee";
import { LuExternalLink } from "react-icons/lu";
// import BrokerFee from "../components/BrokerFee";

const FeeCalculator = () => {
  const countries = [
    { value: 'AllCountry', label: 'All Country' },
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Anguilla', label: 'Anguilla' },
    { value: 'Antigua & Barbuda', label: 'Antigua & Barbuda' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Armenia', label: 'Armenia' },
    { value: 'Aruba', label: 'Aruba' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'China', label: 'China' },
    { value: 'Cyprus', label: 'Cyprus' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Hong Kong', label: 'Hong Kong' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Israel', label: 'Israel' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Kuwait', label: 'Kuwait' },
    { value: 'Luxembourg', label: 'Luxembourg' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Oman', label: 'Oman' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' }
  ];
  const feeData = [
    {
      broker: "Plus500",
      lose: "82",
      link: "https://www.plus500.com",
      img: plus500,
      Country: [
        "AllCountry",
        "Australia",
        "Argentina",
        "Austria",
        "Andorra",
        'Hong Kong',
        "Bahrain",
        "Cyprus",
        "Denmark",
        "Germany",
        "Ireland",
        "Finland",
        "Israel",
        "Japan",
        "Italy",
        "Kuwait",
        "Luxembourg",
        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],
      EURUSD: {
        EURUSD: 1.3,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 2,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 3,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.1,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.2,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.8,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.2,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.30,
        comission: 0,
      },

    },

    {
      broker: "XTB",
      link: "https://www.xtb.com",
      lose: "76",
      img: XTB,
      Country: ['AllCountry',
        'Afghanistan', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Austria', 'Bahrain', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      EURUSD: {
        EURUSD: 0.9,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.5,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.0,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.2,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.6,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.8,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.7,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.6,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.0,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.2,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.28,
        comission: 0,
      },

    },

    {
      broker: "ActivTrades ",
      lose: "81",
      link: "https://www.activtrades.com",
      Country: ['AllCountry', "Egypt", "American Samoa", "Kuwait", "Bahrain", "Oman", "Qatar", "Israel", "Algeria", "Israel", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "Bangladesh", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: activetrade,
      EURUSD: {
        EURUSD: 1.5,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.6,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.7,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.8,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.0,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.5,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.5,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.2,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 2.0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.2,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.4,
        comission: 0,
      },

    },
    {
      broker: "IG ",
      img: IG,
      link: "https://www.ig.com",
      lose: "71",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      EURUSD: {
        EURUSD: 0.7,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.1,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.0,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.3,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.7,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.8,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.1,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.2,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.4,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.2,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.4,
        comission: 0,
      },

    },
    {
      broker: "Pepperstone",
      lose: "74-89",
      link: "https://pepperstone.com",
      type: "Standard Account",
      img: peperstone,
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Ireland', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      EURUSD: {
        EURUSD: 1.0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.2,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.3,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.6,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.2,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.3,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.9,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.7,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.4,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.7,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.16,
        comission: 0,
      },

    },
    {
      broker: "Pepperstone",
      type: "Razor Account",
      lose: "74-89",
      link: "https://pepperstone.com",
      Country: ['AllCountry', "Albania", "Algeria", 'Ireland', "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Iceland", "Ireland", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: peperstone,
      EURUSD: {
        EURUSD: 0.1,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0.3,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0.7,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0.4,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0.3,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0.3,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.8,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 1.5,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0.2,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 1.3,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.6,
        comission: 7
      },
      GOLD: {
        GOLD: 0.19,
        comission: 0
      },



    },
    {
      broker: "FOREX.com",
      lose: "75",
      link: "https://www.forex.com",

      Country: ['AllCountry', "Israel", "American Samoa", "Bahrain", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Standard Account",
      img: forexcom,
      EURUSD: {
        EURUSD: 1.3,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.5,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.4,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.3,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.8,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.9,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.2,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.8,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.9,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.4,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.3,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.3,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.68,
        comission: 0,
      },

    },
    {
      broker: "Fxpro",
      lose: "81.85",
      link: "https://www.fxpro.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Hedging Account",
      img: fxpro,
      EURUSD: {
        EURUSD: 1.2,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.3,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.7,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.9,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.5,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.9,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.9,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.9,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.3,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 4.5,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 3.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.23,
        comission: 0,
      },

    },
    {
      broker: "FxPro",
      lose: "81.85",

      link: "https://www.fxpro.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland"],
      type: "Elite Account",
      img: fxpro,
      EURUSD: {
        EURUSD: 0,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.2,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 0.5,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 0.5,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.5,
        comission: 7
      },
      GOLD: {
        GOLD: 0.11,
        comission: 7
      },


    },
    {
      broker: "FxPro",
      lose: "81.85",

      link: "https://www.fxpro.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland"],
      type: "Raw+ Account",
      img: fxpro,

      EURUSD: {
        EURUSD: 0,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.2,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 0.5,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 0.5,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.5,
        comission: 7
      },
      GOLD: {
        GOLD: 0.11,
        comission: 7
      },


    },
    {
      broker: "City Index",
      link: "https://www.cityindex.com",

      Country: ['AllCountry', "Australia", "United Arab Emirates", "United Kingdom"],
      type: "Raw+ Account",
      img: cityindex,
      lose: "70",
      EURUSD: {
        EURUSD: 1,
        comission: 0
      },
      USDJPY: {
        USDJPY: 1.2,
        comission: 0
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0
      },
      USDCAD: {
        USDCAD: 2,
        comission: 0
      },
      AUDUSD: {
        AUDUSD: 1,
        comission: 0
      },
      NZDUSD: {
        NZDUSD: 1.8,
        comission: 0
      },
      EURJPY: {
        EURJPY: 2.5,
        comission: 0
      },
      GBPJPY: {
        GBPJPY: 3.2,
        comission: 0
      },
      USDCHF: {
        USDCHF: 2.2,
        comission: 0
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0
      },
      NZDJPY: {
        NZDJPY: 4,
        comission: 0
      },
      AUDJPY: {
        AUDJPY: 3,
        comission: 0
      },
      GOLD: {
        GOLD: 0.50,
        comission: 0
      },


    },
    {/*  
    {
      broker: "CMC Markets",
      Country: ['AllCountry', "Luxembourg", "Albania", "Israel", "Algeria",, "Italy", 'Hong Kong', "Australia", "Austria", "Bahrain", "Belgium", "Cyprus", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "United Arab Emirates", "United Kingdom"],
      img: cmc,
      lose: "69",

      EURUSD: {
        EURUSD: 1,
        comission: 0
      },
      USDJPY: {
        USDJPY: 1.2,
        comission: 0
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0
      },
      USDCAD: {
        USDCAD: 2,
        comission: 0
      },
      AUDUSD: {
        AUDUSD: 1,
        comission: 0
      },
      NZDUSD: {
        NZDUSD: 1.8,
        comission: 0
      },
      EURJPY: {
        EURJPY: 2.5,
        comission: 0
      },
      GBPJPY: {
        GBPJPY: 3.2,
        comission: 0
      },
      USDCHF: {
        USDCHF: 2.2,
        comission: 0
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0
      },
      NZDJPY: {
        NZDJPY: 4,
        comission: 0
      },
      AUDJPY: {
        AUDJPY: 3,
        comission: 0
      },
      GOLD: {
        GOLD: 0.50,
        comission: 0
      },


    },
    */},
    {
      broker: "Tickmill",
      lose: "72",
      link: "https://www.tickmill.com",
      Country: ['AllCountry', , "Algeria", "Israel", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Pro Account",
      img: tickmil,
      EURUSD: {
        EURUSD: 0,
        comission: 4
      },
      USDJPY: {
        USDJPY: 0.3,
        comission: 4
      },
      GBPUSD: {
        GBPUSD: 0.1,
        comission: 4
      },
      USDCAD: {
        USDCAD: 0.4,
        comission: 4
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 4
      },
      NZDUSD: {
        NZDUSD: 0.1,
        comission: 4
      },
      EURJPY: {
        EURJPY: 0.3,
        comission: 4
      },
      GBPJPY: {
        GBPJPY: 0.6,
        comission: 4
      },
      USDCHF: {
        USDCHF: 0.3,
        comission: 4
      },
      EURGBP: {
        EURGBP: 0.2,
        comission: 4
      },
      NZDJPY: {
        NZDJPY: 0.6,
        comission: 4
      },
      AUDJPY: {
        AUDJPY: 0.6,
        comission: 4
      },
      GOLD: {
        GOLD: 0.1,
        comission: 4
      },
    },
    {
      broker: "Tickmill",
      lose: "72",
      link: "https://www.tickmill.com",

      Country: ['AllCountry', "Israel", , "Algeria", "Israel", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Classic Account",
      img: tickmil,
      EURUSD: {
        EURUSD: 1.6,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.7,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.8,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.6,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.7,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.1,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.2,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.9,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.7,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.4,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.27,
        comission: 0,
      },

    },
    {
      broker: "Oanda",
      lose: "74-89",
      link: "https://www.oanda.com",
      Country: ['AllCountry', "Algeria", "Israel", , "Andorra", "American Samoa", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: oandalogo,
      EURUSD: {
        EURUSD: 0.7,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 0.8,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0.8,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.6,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.8,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.5,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.5,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.6,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.2,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0.8,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.2,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.4,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.15,
        comission: 0,
      },

    },
    {
      broker: "Admirals Markets",
      lose: "80",
      link: "https://admiralmarkets.com",
      type: "Trade.MT5 Account",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]

      ,
      img: admiralmarket,
      EURUSD: {
        EURUSD: 0.8,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.1,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0.9,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.7,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.1,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.9,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.6,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.1,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.7,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0.9,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.4,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.5,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.55,
        comission: 0,
      },

    },
    {
      broker: "Admirals Markets",
      lose: "80",
      link: "https://admiralmarkets.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      type: "Zero.MT5 Account",
      img: admiralmarket,
      EURUSD: {
        EURUSD: 0.2,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.4,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 0.5,
        comission: 6
      },
      USDCAD: {
        USDCAD: 1.2,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.5,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 1.2,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.9,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 1.5,
        comission: 6
      },
      USDCHF: {
        USDCHF: 1.0,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.7,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 0.9,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 1.6,
        comission: 6
      },
      GOLD: {
        GOLD: 0.24,
        comission: 6
      },

    },
    {
      broker: "eToro ",
      lose: "74-89"
      ,
      link: "https://etoro.com",

      Country: ['AllCountry',
        "Australia", "Austria", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland",
        "France", "Germany", "Ireland", "Italy", "Luxembourg", "Netherlands",
        "Norway", "Oman", "Poland", "Qatar", "Singapore", "South Africa",
        "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"
      ],
      img: etoro,
      EURUSD: {
        EURUSD: 1.0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.5,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.5,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 3.5,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.9,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.6,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.4,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 4.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.6,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.45,
        comission: 0,
      },
    },
    {
      broker: "Capital.com ",
      lose: "79",
      link: "https://www.capital.com",
      Country: ['AllCountry', "Angola", "Algeria", "Albania", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: captial,
      EURUSD: {
        EURUSD: 0.6,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.3,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.9,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.6,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.7,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.5,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.9,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.5,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 2.0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.5,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 0.9,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.5,
        comission: 0,
      },

    },

    {
      broker: "Swissquote ",
      lose: "77",
      link: "https://www.swissquote.com",
      Country: ['AllCountry',
        "Andorra", "Austria", "Australia", "Albania", "Egypt", "Brazil", "Armenia", "Israel", "China", "Bahrain", "Argentina", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
        "Denmark", "Estonia", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Hungary",
        "Iceland", "Ireland", "Isle of Man", "Italy", "Jersey", "Kuwait", "Latvia", "Liechtenstein",
        "Lithuania", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal",
        "Qatar", "Romania", "San Marino", "Saudi Arabia", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland",
        "United Arab Emirates", "United Kingdom"
      ],

      img: swisslogo,
      EURUSD: {
        EURUSD: 1.3,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.5,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.8,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.4,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.5,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.1,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.8,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.9,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.7,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.6,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.5,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.36,
        comission: 0,
      },
    },

    {
      broker: "IC Markets",
      lose: "74-32",
      link: "https://www.icmarkets.com",

      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Raw Spread Account",
      img: ICmarket,

      EURUSD: {
        EURUSD: 0,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0.3,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0.1,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0.1,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.2,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 0.9,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0.1,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 0.5,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.5,
        comission: 7
      },
      GOLD: {
        GOLD: 0.11,
        comission: 7
      },

    },

    {
      broker: "IC Markets ",
      lose: "74-32",

      type: "Standard Account",
      link: "https://www.icmarkets.com",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: ICmarket,
      EURUSD: {
        EURUSD: 0.8,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 0.8,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0.8,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 0.8,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.8,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.3,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.2,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.9,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.2,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.1,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 1.8,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.5,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.19,
        comission: 0,
      },

    },

    {
      broker: "Fusion Markets",
      lose: "74-89",
      link: "https://fusionmarkets.com",
      type: "Zero Account",
      Country: ['AllCountry', "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: fusionmarket,
      EURUSD: {
        EURUSD: 0,
        comission: 4.5
      },
      USDJPY: {
        USDJPY: 0.6,
        comission: 4.5
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 4.5
      },
      USDCAD: {
        USDCAD: 0.1,
        comission: 4.5
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 4.5
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 4.5
      },
      EURJPY: {
        EURJPY: 0.9,
        comission: 4.5
      },
      GBPJPY: {
        GBPJPY: 0.8,
        comission: 4.5
      },
      USDCHF: {
        USDCHF: 0.5,
        comission: 4.5
      },
      EURGBP: {
        EURGBP: 0,
        comission: 4.5
      },
      NZDJPY: {
        NZDJPY: 1.1,
        comission: 4.5
      },
      AUDJPY: {
        AUDJPY: 1.5,
        comission: 4.5
      },
      GOLD: {
        GOLD: 0.15,
        comission: 4.5
      },

    },


    {
      broker: "Fusion Markets",
      type: " Classic Account",
      lose: "74-89",
      link: "https://fusionmarkets.com",
      Country: ['AllCountry', "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: fusionmarket,
      EURUSD: {
        EURUSD: 0.9,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 2.5,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0.9,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 0.9,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.9,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 0.9,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.5,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.4,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.5,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0.9,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.0,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.22,
        comission: 0,
      },

    },

    {
      broker: "XM",
      lose: "74-89",
      link: "https://www.xm.com",
      Country: ['AllCountry', "Algeria", "Andorra", "Angola", "Antigua & Barbuda", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Standard Account",
      img: xtm,
      EURUSD: {
        EURUSD: 1.8,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 3.2,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 2.2,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.4,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 2.2,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.5,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 3.8,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 4.5,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.1,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.9,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.7,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 3.5,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.40,
        comission: 0,
      },

    },

    {
      broker: "FXCM",
      lose: "71",
      link: "https://www.fxcm.com",
      Country: ['AllCountry', "Algeria", "Albania", "Andorra", "Denmark", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Egypt", "Finland", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: fxcmlogo,
      EURUSD: {
        EURUSD: 1.3,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.6,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.9,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.7,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.9,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.4,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.1,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 2.0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.6,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.5,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.30,
        comission: 0,
      },

    },
    {
      /* 
    {
      broker: "ACY Securities",
      lose: "74-89",

      Country: ['AllCountry', "United Arab Emirates", "United Kingdom"],
      img: securites,
      EURUSD: {
        EURUSD: 0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 0,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 0,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 0,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 0,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 0,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 0,
        comission: 0,
      },
      GOLD: {
        GOLD: 0,
        comission: 0,
      },

    },
      */},



    {
      broker: "Global Prime",
      lose: "74-89",
      link: "https://www.globalprime.com",
      Country: ['AllCountry', "Qatar", "Hong Kong", "Austria", "Denmark", "Bahrain", "Belgium", "Bangladesh", "Cyprus", "Kuwait", "Netherlands", "Ireland", "Israel", "Egypt", "American Samoa", "Aruba", "Armenia", "Antigua & Barbuda", "Angola", "Argentina", "Algeria", "Andorra", "Anguilla", "Poland", "Luxembourg", "Switzerland", "Italy", "Spain", "Israel", "Albania", "Saudi Arabia", "Finland", "United States", "China", "India", "Brazil", "United Kingdom", "Germany", "France", "Australia", "Canada", "Japan", "Sweden", "Sweden"],
      type: "Raw Account",
      img: globalprime,

      EURUSD: {
        EURUSD: 0.1,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0.2,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0.3,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0.3,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0.2,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0.4,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.5,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 1.0,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0.4,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 1.0,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.5,
        comission: 7
      },
      GOLD: {
        GOLD: 0.10,
        comission: 7
      },

    },
    {
      broker: "Global Prime",
      link: "https://www.globalprime.com",
      lose: "74-89",

      type: "Standard Account",
      img: globalprime,
      Country: ['AllCountry', "Qatar", "Hong Kong", "Austria", "Denmark", "Bahrain", "Belgium", "Bangladesh", "Cyprus", "Kuwait", "Netherlands", "Ireland", "Israel", "Egypt", "American Samoa", "Aruba", "Armenia", "Antigua & Barbuda", "Angola", "Argentina", "Algeria", "Andorra", "Anguilla", "Poland", "Luxembourg", "Switzerland", "Italy", "Spain", "Israel", "Albania", "Saudi Arabia", "Finland", "United States", "China", "India", "Brazil", "United Kingdom", "Germany", "France", "Australia", "Canada", "Japan", "Sweden", "Sweden"],
      EURUSD: {
        EURUSD: 1.0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.3,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.3,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.2,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.0,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.2,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.5,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.9,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.2,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 1.9,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.4,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.20,
        comission: 0,
      },

    },

    {
      broker: "AvaTrade ",
      link: "https://www.avatrade.com",
      lose: "76",

      Country: ['AllCountry', "American Samoa", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: avatrade,
      EURUSD: {
        EURUSD: 0.9,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.0,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.1,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.8,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.8,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.5,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.6,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.7,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.36,
        comission: 0,
      },

    },

    {
      broker: "FP Markets",
      link: "https://www.fpmarkets.com",
      lose: "74-89",
      type: "Raw Account",
      Country: ['AllCountry', "Qatar", "Bangladesh", "Bahrain", "Egypt", "Kuwait", "Israel", "Algeria", "Oman", "Albania", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: fpmarket,

      EURUSD: {
        EURUSD: 0.1,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.3,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 0.2,
        comission: 6
      },
      USDCAD: {
        USDCAD: 0.4,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.3,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 0.6,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.2,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 0.8,
        comission: 6
      },
      USDCHF: {
        USDCHF: 0.5,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.1,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 1.0,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 0.3,
        comission: 6
      },
      GOLD: {
        GOLD: 0.12,
        comission: 6
      },

    },

    {
      broker: "Multibank",
      link: "https://www.multibank.com",

      lose: "74-89",

      type: "PRO Account",
      Country: ['AllCountry', "American Samoa", "Israel", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: multibank,

      EURUSD: {
        EURUSD: 0.8,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 0.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0.8,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 0.8,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0.7,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 0.8,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.1,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 1.3,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 0.8,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0.9,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 1.4,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.15,
        comission: 0,
      },

    },

    {
      broker: "Eightcap",
      link: "https://www.eightcap.com",
      lose: "77.78",

      type: "Standard Account",
      Country: ['AllCountry', "Angola", "Aruba", "Oman", "Egypt", "Bangladesh", "American Samoa", "Bahrain", "China", "Kuwait", "Armenia", "Algeria", "Argentina", "Saudi Arabia", "Italy", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Australia", "Austria", "Belgium", "Brazil", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Luxembourg", "Netherlands", "New Zealand", "Poland", "Singapore", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      img: Eightcap,
      EURUSD: {
        EURUSD: 1.0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.3,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.3,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.2,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.2,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.5,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.7,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.0,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 1.7,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.12,
        comission: 0,
      },

    },

    {
      broker: "Vantage",
      type: "Raw Account",
      link: "https://www.vantagemarkets.com",
      lose: "81",

      Country: ['AllCountry', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,
      img: vintage,
      EURUSD: {
        EURUSD: 0.2,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.5,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 0.2,
        comission: 6
      },
      USDCAD: {
        USDCAD: 0.7,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.3,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 0.6,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.5,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 0.3,
        comission: 6
      },
      USDCHF: {
        USDCHF: 0.2,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 0.7,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 0.7,
        comission: 6
      },
      GOLD: {
        GOLD: 0.10,
        comission: 6
      },

    },
    {
      broker: "Trade Nation",
      link: "https://www.tradenation.com",
      lose: "74-89",


      Country: ['AllCountry', 'Albania', 'Algeria', 'Andorra', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,
      img: tradenation,
      EURUSD: {
        EURUSD: 0.2,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.5,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 0.2,
        comission: 6
      },
      USDCAD: {
        USDCAD: 0.7,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.3,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 0.6,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.5,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 0.3,
        comission: 6
      },
      USDCHF: {
        USDCHF: 0.2,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 0.7,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 0.7,
        comission: 6
      },
      GOLD: {
        GOLD: 0.10,
        comission: 6
      },

    },

    {
      broker: "HYCM ",
      link: "https://www.hycm.com",
      lose: "74-89",

      Country: ['AllCountry', "Israel", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      type: "Raw Account",
      img: Hycmlogo,
      EURUSD: {
        EURUSD: 0.2,
        comission: 8
      },
      USDJPY: {
        USDJPY: 0.2,
        comission: 8
      },
      GBPUSD: {
        GBPUSD: 0.4,
        comission: 8
      },
      USDCAD: {
        USDCAD: 0.6,
        comission: 8
      },
      AUDUSD: {
        AUDUSD: 0.4,
        comission: 8
      },
      NZDUSD: {
        NZDUSD: 0.8,
        comission: 8
      },
      EURJPY: {
        EURJPY: 0.7,
        comission: 8
      },
      GBPJPY: {
        GBPJPY: 1.5,
        comission: 8
      },
      USDCHF: {
        USDCHF: 0.5,
        comission: 8
      },
      EURGBP: {
        EURGBP: 0.6,
        comission: 8
      },
      NZDJPY: {
        NZDJPY: 1.5,
        comission: 8
      },
      AUDJPY: {
        AUDJPY: 1.0,
        comission: 8
      },
      GOLD: {
        GOLD: 0.19,
        comission: 8
      },

    },

    {
      broker: "HFM ",
      link: "https://www.hfm.com",
      lose: "74-89",
      type: " Premium Account",
      Country: ['AllCountry', "United Arab Emirates"
        , "United Kingdom"],

      img: HFmarket,
      EURUSD: {
        EURUSD: 1.5,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 2.1,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 2.1,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.7,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 2.0,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.2,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.9,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 3.4,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.3,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.8,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 3.3,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 3.0,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.35,
        comission: 0,
      },

    },

    {
      broker: "Moneta Markets",
      link: "https://www.monetamarkets.com",
      lose: "74-89",

      type: "Prime Account",
      Country: ['AllCountry', "Andorra", "Algeria", "Angola", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Denmark", "Egypt", "Finland", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates"],
      img: monetamarket,
      EURUSD: {
        EURUSD: 0.2,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.4,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 0.7,
        comission: 6
      },
      USDCAD: {
        USDCAD: 0.8,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.6,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 0.7,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.6,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 0.4,
        comission: 6
      },
      USDCHF: {
        USDCHF: 0.7,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.5,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 0.9,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 0.9,
        comission: 6
      },
      GOLD: {
        GOLD: 0.15,
        comission: 6
      },

    },

    {
      broker: "GO Markets",
      link: "https://www.gomarkets.com",
      type: "Plus Account",
      lose: "74-89",

      Country: ['AllCountry', "Luxembourg", "Oman", "Egypt", "Brazil", "Bangladesh", "Cyprus", "Ireland", "Denmark", "Austria", "Netherlands", "Bahrain", "Hong Kong", "Armenia", "Angola", "Aruba", "Antigua & Barbuda", "Albania", "Andorra", "Argentina", "Algeria", "Poland", "Sweden", "Japan", "Italy", "Australia", "France", "Finland", "Germany", "United Kingdom", "Kuwait", "South Africa", "Saudi Arabia", "United Arab Emirates", "New Zealand"]
      ,
      img: gomarket,
      EURUSD: {
        EURUSD: 0.1,
        comission: 5
      },
      USDJPY: {
        USDJPY: 0.4,
        comission: 5
      },
      GBPUSD: {
        GBPUSD: 0.3,
        comission: 5
      },
      USDCAD: {
        USDCAD: 0.4,
        comission: 5
      },
      AUDUSD: {
        AUDUSD: 0.2,
        comission: 5
      },
      NZDUSD: {
        NZDUSD: 0.3,
        comission: 5
      },
      EURJPY: {
        EURJPY: 0.8,
        comission: 5
      },
      GBPJPY: {
        GBPJPY: 1.3,
        comission: 5
      },
      USDCHF: {
        USDCHF: 0.5,
        comission: 5
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 5
      },
      NZDJPY: {
        NZDJPY: 1.0,
        comission: 5
      },
      AUDJPY: {
        AUDJPY: 0.5,
        comission: 5
      },
      GOLD: {
        GOLD: 0.20,
        comission: 0
      },

    },


    {
      broker: "Markets.com",
      link: "https://www.markets.com",
      lose: "67.7",

      img: marketcom,
      Country: ['AllCountry', "Saudi Arabia", "Egypt", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      EURUSD: {
        EURUSD: 0.6,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.5,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 1.7,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.0,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 2.0,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 1.8,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 4.0,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 2.0,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.5,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.8,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.0,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.30,
        comission: 0,
      },

    },
    {
      broker: "FXTM",
      link: "https://www.forextime.com",
      lose: "67.7",
      img: fxtm,
      Country: ['AllCountry', "Afghanistan", "Israel", "Algeria", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Egypt", "Iceland", "Kuwait", "New Zealand", "Norway", "Oman", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      EURUSD: {
        EURUSD: 0,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 0,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 0,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 0,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 0,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 0,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 0,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 0,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 0,
        comission: 0,
      },
      GOLD: {
        GOLD: 0,
        comission: 0,
      },

    },

    {
      broker: "Blackbull",
      link: "https://www.blackbull.com",
      lose: "74-89",

      type: "Prime Account",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      img: blackbull,

      EURUSD: {
        EURUSD: 0.1,
        comission: 6
      },
      USDJPY: {
        USDJPY: 0.7,
        comission: 6
      },
      GBPUSD: {
        GBPUSD: 1.0,
        comission: 6
      },
      USDCAD: {
        USDCAD: 0.7,
        comission: 6
      },
      AUDUSD: {
        AUDUSD: 0.6,
        comission: 6
      },
      NZDUSD: {
        NZDUSD: 0.7,
        comission: 6
      },
      EURJPY: {
        EURJPY: 0.8,
        comission: 6
      },
      GBPJPY: {
        GBPJPY: 0.9,
        comission: 6
      },
      USDCHF: {
        USDCHF: 0.8,
        comission: 6
      },
      EURGBP: {
        EURGBP: 0.6,
        comission: 6
      },
      NZDJPY: {
        NZDJPY: 1.2,
        comission: 6
      },
      AUDJPY: {
        AUDJPY: 1.2,
        comission: 6
      },
      GOLD: {
        GOLD: 0.12,
        comission: 6
      },

    },
    {
      broker: "Axi",
      link: "https://www.axi.com",
      lose: "83.1",

      type: "Prime Account",
      Country: ['AllCountry',
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Bahrain",
        "Bangladesh",
        "Belgium",
        "Brazil",
        "China",
        "Cyprus",
        "Denmark",
        "Egypt",
        "Finland",
        "France",
        "Germany",
        "Hong Kong",
        "Ireland",
        "Israel",
        "Italy",

        "Kuwait",

        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Spain",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],
      img: axi,

      EURUSD: {
        EURUSD: 0,
        comission: 0
      },
      USDJPY: {
        USDJPY: 0,
        comission: 0
      },
      GBPUSD: {
        GBPUSD: 0,
        comission: 0
      },
      USDCAD: {
        USDCAD: 0,
        comission: 0
      },
      AUDUSD: {
        AUDUSD: 0,
        comission: 0
      },
      NZDUSD: {
        NZDUSD: 0,
        comission: 0
      },
      EURJPY: {
        EURJPY: 0,
        comission: 0
      },
      GBPJPY: {
        GBPJPY: 0,
        comission: 0
      },
      USDCHF: {
        USDCHF: 0,
        comission: 0
      },
      EURGBP: {
        EURGBP: 0,
        comission: 0
      },
      NZDJPY: {
        NZDJPY: 0,
        comission: 0
      },
      AUDJPY: {
        AUDJPY: 0,
        comission: 0
      },
      GOLD: {
        GOLD: 0,
        comission: 0
      }

    },
    {/* 
    {
      broker: "Skilling ",
      type: "Standard Account",
      Country: ['AllCountry',  "United Arab Emirates"
      ,"United Kingdom"],
      img: fpmarket,
      EURUSD: {
        EURUSD: 1.3,
        comission: 0,
      },
      USDJPY: {
        USDJPY: 1.7,
        comission: 0,
      },
      GBPUSD: {
        GBPUSD: 1.7,
        comission: 0,
      },
      USDCAD: {
        USDCAD: 2.2,
        comission: 0,
      },
      AUDUSD: {
        AUDUSD: 1.7,
        comission: 0,
      },
      NZDUSD: {
        NZDUSD: 1.8,
        comission: 0,
      },
      EURJPY: {
        EURJPY: 2.0,
        comission: 0,
      },
      GBPJPY: {
        GBPJPY: 2.2,
        comission: 0,
      },
      USDCHF: {
        USDCHF: 1.9,
        comission: 0,
      },
      EURGBP: {
        EURGBP: 1.7,
        comission: 0,
      },
      NZDJPY: {
        NZDJPY: 2.1,
        comission: 0,
      },
      AUDJPY: {
        AUDJPY: 2.1,
        comission: 0,
      },
      GOLD: {
        GOLD: 0.38,
        comission: 0,
      },
    },
  */}
    ,
    {
      broker: "TMGM",
      link: "https://www.tmgm.com",
      lose: "74-89",

      type: " Edge Account",
      Country: ['AllCountry',
        'Afghanistan', 'Albania', "Israel", 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      img: tmgm,
      EURUSD: {
        EURUSD: 0,
        comission: 7
      },
      USDJPY: {
        USDJPY: 0.2,
        comission: 7
      },
      GBPUSD: {
        GBPUSD: 0.2,
        comission: 7
      },
      USDCAD: {
        USDCAD: 0.2,
        comission: 7
      },
      AUDUSD: {
        AUDUSD: 0.1,
        comission: 7
      },
      NZDUSD: {
        NZDUSD: 0.3,
        comission: 7
      },
      EURJPY: {
        EURJPY: 0.4,
        comission: 7
      },
      GBPJPY: {
        GBPJPY: 0.9,
        comission: 7
      },
      USDCHF: {
        USDCHF: 0.4,
        comission: 7
      },
      EURGBP: {
        EURGBP: 0.3,
        comission: 7
      },
      NZDJPY: {
        NZDJPY: 1.2,
        comission: 7
      },
      AUDJPY: {
        AUDJPY: 0.3,
        comission: 7
      },
      GOLD: {
        GOLD: 0.10,
        comission: 7
      },

    },


  ];
  const [show, setShow] = useState(false);
  // const {data,setData} = useContext(LoaderContext)
  // console.log("data--->", data);

  const [SelectCountry, setSelectedCountry] = useState();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [SelectCountry])
  const [, setCalculate] = useState(false);
  const [selectedBroker, setSelectedBroker] = useState([]);
  const [newfilterdata, setnewfilterdata] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedCurrencyPair, setSelectedCurrencyPair] = useState("EURUSD");
  // const [userData, setUserData] = useState(null);
  
  
  const countryCodes = {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BE': 'Belgium',
    'BR': 'Brazil',
    'CN': 'China',
    'CY': 'Cyprus',
    'DK': 'Denmark',
    'EG': 'Egypt',
    'FI': 'Finland',
    'FR': 'France',
    'DE': 'Germany',
    'HK': 'Hong Kong',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JP': 'Japan',
    'KW': 'Kuwait',
    'LU': 'Luxembourg',
    'NL': 'Netherlands',
    'NZ': 'New Zealand',
    'OM': 'Oman',
    'PL': 'Poland',
    'QA': 'Qatar',
    'SA': 'Saudi Arabia',
    'SG': 'Singapore',
    'ZA': 'South Africa',
    'ES': 'Spain',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'AE': 'United Arab Emirates',
    'UAE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'PK': 'AllCountry',
    'US': 'AllCountry',
    'RU': 'AllCountry',
    'TR': 'AllCountry',
    'IN': 'AllCountry',
    'CA': 'AllCountry',
    'MX': 'AllCountry',
    'NG': 'AllCountry',
  };


  // useEffect(() => {
  //   const condition = userData && Object.values(countryCodes).includes(userData) ? userData : "AllCountry";
  //   setSelectedCountry(condition);
  //   // setSelectedCountry({ label: condition, value: condition });
    
  // }, [userData]);
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json?token=dec4b91441eb65');
        const data = await response.json();
        const fullCountry = countryCodes[data.country];
        // console.log(countryCodes[data.country],"countryCodes[data.country]")
        // setUserData(fullCountry || data.country);
        // const condition = fullCountry ? fullCountry : "AllCountry";
        const condition = fullCountry && Object.values(countryCodes).includes(fullCountry) ? fullCountry : "AllCountry";
        setSelectedCountry(condition);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
  }, []);
  console.log('SelectCountry---->', SelectCountry);

  const newdata = feeData.filter(broker => broker.Country?.includes(SelectCountry));
  const CalculateBroker = () => {
    setLoading(true);
    setTimeout(() => {
      setCalculate(true);
      setLoading(false);
    }, 500);
  };

  const options = useMemo(() => feeData?.filter(broker => broker.Country?.includes(SelectCountry)).map((e) => {
    return { label: `${e?.broker}`, value: e?.broker };
  }), [SelectCountry, feeData]);

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "435px", // Set the default width to 400 pixels
      "@media (max-width: 600px)": {
        width: "300px"
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999,
      width: "435px",
      "@media (max-width: 600px)": {
        width: "300px"
      }
    })
  };
  const handleChange = (selectedOptions) => {
    setSelectedBroker(selectedOptions);
    let brokers = selectedOptions.map((e) => e.value);
    // setSelectedBrokers(selectedBrokers.filter((item)=>brokers.includes(item.broker)))
    let data = feeData.filter((item) => brokers.includes(item.broker))
    console.log("data-->", data);
    setnewfilterdata([...data])
    console.log("brokers", brokers);
  };

  console.log(options);
  const handleCurrencyPairChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCurrencyPair(selectedValue);
    console.log(selectedValue);
  };
  const handleCountry = (event) => {
    setSelectedCountry(event.value);
  };

  return (
    
    <>
      <Header />
      { SelectCountry? 
<>

      <section className="feeCalculator ">
        <div className="container py-5">
          <div className="col-lg-10 col-md-9 offset-md-1">
            <div className="top-heading d-flex ">
              <div className="d-flex align-items-center">
                <p className="feeCalculator-new px-2 mx-2 fw-bold">NEW</p>
              </div>
              <h1 className="feeCalculator-heading fw-bold pt-2 py-3">
                FX Fee Calculator
              </h1>
            </div>

            <div class="text-white lh-base">
              <p className="p-0 m-0">Calculate your FX trading fees.</p>
              <ul className="feeCalculator-list lh-lg">
                <li>
                  Enter your currency pair, trade size, and select your country.
                </li>
                <li>
                  Get the brokers with the lowest fees for FX trading starting
                  with the cheapest.
                </li>
                <li>
                  The fee calculation will show both spreads and FX commissions.
                </li>
              </ul>
            </div>
            <div className="formarea ">
              <div className="row">
                <div className="col-lg-6 col-md-6 mt-3">
                  <p className="input-label fw-bold">Currency pair</p>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={selectedCurrencyPair || ''}
                    onChange={handleCurrencyPairChange}
                  >
                    <option value="EURUSD">EURUSD</option>
                    <option value="USDJPY">USDJPY</option>
                    <option value="GBPUSD">GBPUSD</option>
                    <option value="USDCAD">USDCAD</option>
                    <option value="AUDUSD">AUDUSD</option>
                    <option value="NZDUSD">NZDUSD</option>
                    <option value="EURJPY">EURJPY</option>
                    <option value="GBPJPY">GBPJPY</option>
                    <option value="USDCHF">USDCHF</option>
                    <option value="EURGBP">EURGBP</option>
                    <option value="NZDJPY">NZDJPY</option>
                    <option value="AUDJPY">AUDJPY</option>
                    <option value="GOLD">GOLD</option>
                  </select>{" "}
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mt-3 " >
                  <div className="row whats" >
                    <div className="col-lg-6 col-md-6 ">
                      <p className="input-label fw-bold">Select Country</p>
                    
                      <Select
                        options={countries}
                        defaultValue={{label:SelectCountry, value:SelectCountry}}
                        styles={selectStyles}
                        onChange={handleCountry}
                        
                      />

                      {" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" >
                <div className="col-lg-6 col-md-6 mt-3">
                  <p className="input-label fw-bold">Select Broker</p>

                  <Select
                    onChange={handleChange}

                    isMulti={true}
                    isSearchable={true}
                    value={selectedBroker}
                    styles={selectStyles}
                    options={options}
                  />{" "}
                </div>
              </div>
              <div className="row ">
                <div className="col-md-6 mt-3">
                  <button
                    type="button"
                    class="btn btn-primary w-100 align-items-center justify-content-center text-uppercase"
                    onClick={() => {
                      CalculateBroker();
                    }}
                  >
                    {loading ? (
                      <Oval
                        height={18}
                        width={18}
                        color="#fff"
                        text
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#fff"
                        strokeWidth={6}
                        strokeWidthSecondary={6}
                      />
                    ) : (
                      "Compare"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="BrokerFeeSection">
        <div className="container py-5">
          <div className="col-lg-10 col-md-9 offset-md-1">
            <div className="top-heading text-center">
              <h3 className="fw-bold pt-2 py-3">
                Average Spread For {selectedCurrencyPair}
              </h3>

              {SelectCountry ? (
                <p className="fw-bold BrokerFeeSection-para">
                  (All fees are in USD)
                </p>
              ) : (
                <p className="fw-bold BrokerFeeSection-para">

                </p>
              )}
            </div>

            {newfilterdata.length === 0 ?

              newdata?.map(e => {
                return (<div className="d-flex align-items-center justify-content-between calculate-broker  my-3 row">
                  <div className="col-lg-3 col-md-12 col-sm-12">
                    <div className="broker-profile d-flex align-items-center justify-content-start p-2 resFee">
                      <img
                        className="shadow1"
                        src={e?.img}
                        alt=""
                        onClick={() => window.open(e?.link, "_blank")}
                        width="60"
                        height="60"
                        style={{ borderRadius: "10px", cursor: "pointer" }}
                      />
                      <div className="px-3 m">

                        <h6 className="broker-profile-name-1 fw-bold fs-6">
                          {e?.broker}
                        </h6>
                        <h6 className="broker-profile-name-2 fw-bold fs-6 para-color">
                          {e?.type}
                        </h6>
                      </div>
                    </div>
                  </div>


               
                  <div className="col-lg-2 col-md-4 col-sm-4">
                    <div className="broker-spread text-center new">
                      <p className="para-color p-0 m-2">Spread</p>
                      <h5 className="broker-profile-name-2 fw-bold  fs-4 cur">{e?.[selectedCurrencyPair]?.[selectedCurrencyPair]}</h5>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-4 ">
                    <div className="broker-comission text-center new1">
                      <p className="para-color p-0 m-2">Commission</p>
                      <h5 className="broker-profile-name-2 fw-bold  fs-4 cur1">${e?.[selectedCurrencyPair]?.comission}</h5>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12">
                    <div className="broker-percentage text-center p-2">
                      <div className="link-btn pb-3">
                        <div className="theme-btn btn-style-two">
                          <span
                            className="btn-title"
                            onClick={() => window.open(e?.link, "_blank")}
                            style={{
                              padding: "3px 7px",
                              cursor: "pointer"
                            }}
                          >
                            VISIT BROKER{" "}
                            <LuExternalLink size="22" style={{ paddingBottom: "5px" }} />{" "}
                          </span>
                        </div>
                      </div>
                      <p className="percentage-para p-0 m-2">
                        {e?.lose}% of retail CFD accounts lose money
                      </p>
                    </div>
                  </div>
                </div>)
              })
              :
              null
            }
            {newfilterdata?.map(e => {
              return (<div className="d-flex align-items-center justify-content-between calculate-broker  my-3 row" >
                <div className="col-lg-3 col-md-12 col-sm-12" >
                  <div className="broker-profile d-flex align-items-center justify-content-start p-2">
                    <img
                      className="shadow1"
                      src={e?.img}
                      onClick={() => window.open(e?.link, "_blank")}
                      alt=""
                      width="60"
                      height="60"
                      style={{ borderRadius: "10px", cursor: "pointer" }}
                    />
                    <div className="px-3">

                      <h6 className="broker-profile-name-1 fw-bold fs-6">
                        {e?.broker}
                      </h6>
                      <h6 className="broker-profile-name-2 fw-bold fs-6 para-color">
                        {e?.type}
                      </h6>
                    </div>
                  </div>
                </div>



                <div className="col-lg-2 col-md-4 col-sm-4">
                  <div className="broker-spread text-center">
                    <p className="para-color p-0 m-2">Spread</p>
                    <h5 className="broker-profile-name-2 fw-bold  fs-4 ">{e?.[selectedCurrencyPair]?.[selectedCurrencyPair]}</h5>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-4">
                  <div className="broker-comission text-center">
                    <p className="para-color p-0 m-2">Commission</p>
                    <h5 className="broker-profile-name-2 fw-bold  fs-4 ">${e?.[selectedCurrencyPair]?.comission}</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12">
                  <div className="broker-percentage text-center p-2">
                    <div className="link-btn pb-3">
                      <div className="theme-btn btn-style-two">
                        <span
                          className="btn-title"
                          onClick={() => window.open(e?.link, "_blank")}

                          style={{
                            padding: "3px 7px",
                            cursor: "pointer"
                          }}
                        >
                          VISIT BROKER{" "}
                          <LuExternalLink size="22" style={{ paddingBottom: "5px" }} />{" "}
                        </span>
                      </div>
                    </div>
                    <p className="percentage-para p-0 m-2">
                      74-89% of retail CFD accounts lose money
                    </p>
                  </div>
                </div>
              </div>)
            })}

            <div
              className="link-btn pb-3 text-center"
              onClick={() => {
                setShow(!show);
              }}
            >
              <div className="theme-btn btn-style-two">

              </div>
            </div>


          </div>
        </div>
      </section>
      </>
      :<div className="Loader"></div>


    }
      <Footer />
    </>
  );
};

export default FeeCalculator;
